var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classComputed,attrs:{"data-file":_vm.fileExt}})
}
var staticRenderFns = []

export { render, staticRenderFns }